angular.module('unergie.main')
.controller('providerOffersCtrl', ($scope, $state, $uibModal, TableGeneratorService, AlertManager, ProviderOffersApi, TogglerUtils, FileUploader, NgTableParams,
    BoFeaturesService, ErrorCatcher, organizations) => {
    $scope.booleanFilter = [{ id: 'true', title: 'Oui' }, { id: 'false', title: 'Non' }]
    $scope.isPlum = TogglerUtils.isPlum()

    $scope.selectable_by_mapping = _.map(organizations, (d) => ({ label: d.id, value: d.id }))
    $scope.selectable_by_mapping.push({ label: 'client', value: 'client' })
    $scope.selectable_by_mapping.push({ label: 'Toutes les organisations', value: '*' })

    $scope.canUploadProviderOfferFis = BoFeaturesService.isFeatureOn('canUploadProviderOfferFis')

    const fisUploaderFactory = (offer) => {
        return new FileUploader({
            url: `/api-admin/ref-provider-offers/${offer.id}/upload-fis`,
            alias: 'file',
            autoUpload: true,
            method: 'POST',
            onBeforeUploadItem() {
                offer.uploading = true
            },
            onSuccessItem(item, response, status, headers) {
                AlertManager.success(`Fichier FIS uploadé pour l'offre ${offer.id}`)
                offer.uploading = false
            },
            onErrorItem(item, response, status, headers) {
                AlertManager.error(response.message, 10000)
                offer.uploading = false
            },
        })
    }

    $scope.providerOffers = {
        show: {},
        refreshing: false,
        columns: {
            id: { label: 'Id', mode: 'search_wildcard', mandatory: true },
            comments: { label: 'Commentaires', mode: 'search_wildcard' },
            has_pot: { label: 'Offre cagnotte', mode: $scope.isPlum ? 'search_strict' : 'hidden' },
            label: { label: 'Libellé', mode: 'search_wildcard' },
            description: { label: 'Description', mode: 'search_wildcard' },
            energy_type: { label: 'Type énergie', mode: 'search_wildcard' },
            segments: { label: 'Segments', mode: 'search_wildcard' },
            cost_stacking: { label: 'Empilement', mode: 'search_strict' },
            certificate_included: { label: 'CEE inclus', mode: 'search_strict' },
            green_included: { label: 'GO inclus', mode: 'search_strict' },
            elec_type: { label: `Type d'électricité`, mode: $scope.isPlum ? 'search_wildcard' : 'hidden' },
            elec_type_tooltip: { label: `Tooltip type d'électricité`, mode: $scope.isPlum ? 'search_wildcard' : 'hidden' },
            selectable_by: { label: 'Disponible pour', mode: 'search_wildcard' },
            fis: { label: 'FIS', mode: 'hidden' },
        },
    }

    const transform = (offers) => {
        _.each(offers, (offer) => {
            return Object.assign(offer, {
                fisUploader: fisUploaderFactory(offer),
            })
        })
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.providerOffers, 'ref-provider-offers', null, transform, { orderBy: 'id' })

    $scope.newOfferUploader = new FileUploader({
        url: `/api-user/provider-offers/upload-xlsx`,
        alias: 'file',
        formData: [{}],
        autoUpload: true,
        method: 'POST',
        onBeforeUploadItem() {
            $scope.uploading = true
            _.remove($scope.providerOffers.instance.data, { pending: true })
        },
        onSuccessItem(item, response, status, headers) {
            AlertManager.success(`Format de l'offre correct, visualisez la configuration avant de valider la nouvelle offre`)
            const providerOffer = _.assign({ pending: true, expanded: true }, response.providerOffer)
            providerOffer.versions = [{ id: 'new', label: `${moment(response.providerOffer.since).format('DD/MM/YYYY')} *` }]
            providerOffer.version = 'new'
            providerOffer.new = response
            $scope.providerOffers.instance.data.unshift(providerOffer)
            updateProviderOfferTables(providerOffer, providerOffer.new)
            $scope.uploading = false
        },
        onErrorItem(item, response, status, headers) {
            AlertManager.error(response.message, 10000, response.detail)
            $scope.uploading = false
        },
    })


    function updateProviderOfferTables(providerOffer, tariffs) {
        if (tariffs) {
            providerOffer.tables = {
                subscriptionsElec: new NgTableParams({ count: 30 }, { counts: [], dataset: tariffs.subscriptionsElec }),
                consumptionsElec: new NgTableParams({ count: 30 }, { counts: [], dataset: tariffs.consumptionsElec }),
                greens: new NgTableParams({ count: 30 }, { counts: [], dataset: tariffs.greens }),
                capacitiesCoefElec: new NgTableParams({ count: 30 }, { counts: [], dataset: tariffs.capacitiesCoefElec }),
                capacitiesPriceElec: new NgTableParams({ count: 30 }, { counts: [], dataset: tariffs.capacitiesPriceElec }),
                savingCertificates: new NgTableParams({ count: 30 }, { counts: [], dataset: tariffs.savingCertificates }),
            }
            providerOffer.tariffs = tariffs
        }
        providerOffer.uploader = new FileUploader({
            url: `/api-user/provider-offers/upload-xlsx`,
            alias: 'file',
            formData: [{ id: providerOffer.id }],
            autoUpload: true,
            method: 'POST',
            onBeforeUploadItem() {
                providerOffer.uploading = true
                providerOffer.new = null
                _.remove(providerOffer.versions, { id: 'new' })
                if (providerOffer.version === 'new') {
                    if (providerOffer.versions.length) {
                        providerOffer.version = providerOffer.versions[0].id
                        $scope.getProviderOfferVersion(providerOffer)
                    } else {
                        providerOffer.tables = null
                    }
                }
            },
            onSuccessItem(item, response, status, headers) {
                AlertManager.success(`Format de l'offre correct, visualisez la configuration avant de valider la nouvelle version`)
                providerOffer.new = response
                providerOffer.versions.push({ id: 'new', label: `${moment(response.providerOffer.since).format('DD/MM/YYYY')} *` })
                providerOffer.version = 'new'
                providerOffer.override = !!_.find(providerOffer.versions, { id: response.providerOffer.since })
                updateProviderOfferTables(providerOffer, providerOffer.new)
                providerOffer.uploading = false
            },
            onErrorItem(item, response, status, headers) {
                AlertManager.error(response.message, 10000, response.detail)
                providerOffer.uploading = false
            },
        })
    }

    $scope.getProviderOfferVersion = (providerOffer) => {
        if (providerOffer.version === 'new') {
            return updateProviderOfferTables(providerOffer, providerOffer.new)
        }
        providerOffer.refreshingVersion = true
        return ProviderOffersApi.getProviderOfferAtDate({ id: providerOffer.id, since: providerOffer.version }).$promise.then((tariffs) => {
            updateProviderOfferTables(providerOffer, tariffs)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            providerOffer.refreshingVersion = false
        })
    }

    const fetchProviderOfferVersions = (providerOffer) => {
        providerOffer.refreshingVersions = true
        return ProviderOffersApi.getProviderOfferVersions({ id: providerOffer.id }).$promise.then((versions) => {
            let current
            providerOffer.versions = _.map(versions, (version) => {
                const mVersion = moment(version)
                if (mVersion.isSameOrBefore(moment().startOf('day')) && (!current || mVersion.isAfter(moment(current)))) {
                    current = version
                }
                return { id: version, label: mVersion.format('DD/MM/YYYY') }
            })
            providerOffer.version = current || (providerOffer.versions.length && providerOffer.versions[0].id)
            if (providerOffer.versions.length) {
                return $scope.getProviderOfferVersion(providerOffer)
            }
            updateProviderOfferTables(providerOffer)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            providerOffer.refreshingVersions = false
        })
    }

    const filterPreviousFields = (obj) => _.omitBy(obj, (v, k) => k.startsWith('$previous_'))

    $scope.createOrUpdateOffer = (providerOffer) => {
        const payload = {
            providerOffer: filterPreviousFields(providerOffer.new.providerOffer),
            subscriptionsElec: providerOffer.new.subscriptionsElec && _.map(providerOffer.new.subscriptionsElec, filterPreviousFields),
            consumptionsElec: providerOffer.new.consumptionsElec && _.map(providerOffer.new.consumptionsElec, filterPreviousFields),
            greens: providerOffer.new.greens && _.map(providerOffer.new.greens, filterPreviousFields),
            capacitiesCoefElec: providerOffer.new.capacitiesCoefElec && _.map(providerOffer.new.capacitiesCoefElec, filterPreviousFields),
            capacitiesPriceElec: providerOffer.new.capacitiesPriceElec && _.map(providerOffer.new.capacitiesPriceElec, filterPreviousFields),
            savingCertificates: providerOffer.new.savingCertificates && _.map(providerOffer.new.savingCertificates, filterPreviousFields),
        }
        providerOffer.updating = true
        return Promise.resolve().then(() => {
            if (providerOffer.pending) {
                return ProviderOffersApi.createProviderOffer(payload).$promise
            }
            return ProviderOffersApi.updateProviderOffer({ id: providerOffer.id }, payload).$promise
        })
        .then(() => {
            AlertManager.success(`Nouvelle version de l'offre créée`)
            return fetchProviderOfferVersions(providerOffer)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            providerOffer.updating = false
            if (providerOffer.pending) {
                $scope.refresh()
            }
        })
    }

    $scope.expandProviderOffer = function (providerOffer) {
        if (!providerOffer.refreshingVersions) {
            providerOffer.expanded = !providerOffer.expanded
            if (!providerOffer.fetched && !providerOffer.pending) {
                return fetchProviderOfferVersions(providerOffer)
            }
        }
    }

    $scope.getLineClass = (version, elem) => ({
        'red-bold striked': elem.$deleted,
        'green-bold': version === 'new' && (elem.$previous_unit_price === null || elem.$previous_coef === null) && !elem.$deleted,
        'blue-bold': version === 'new' && (elem.$previous_unit_price != null || elem.$previous_coef != null) && !elem.$deleted,
    })

    $scope.refresh()
})
